
const state = {
  id: null,
  locked: false,
  options: {
    attachable: {
      required: false,
      string: '',
    },
    digital: {
      custom_domain: false,
      templatable: false,
      type: '',
    },
    locked: false,
    proposal: {
      templatable: false,
      type: '',
    },
    skip_quotes: false,
    social_media: {
      buildable: false,
      templatable: false,
    },
  },
  orderable: true,
  reference_title: '',
  service_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'service_id' },
  { key: 'title' },
]

export default state
